import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';

function hasPhotos(photos) {
  if (!photos) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length !== 0;
  }
  return false;
}

function formatPhotos(photos) {
  if (hasPhotos(photos)) {
    const photoList = [];
    photos.forEach(photo => {
      if (photo.photo) {
        photoList.push(
          <div key={photo.id} className="col-md-3">
            <div className="hotel-photo-underlay hotel-photo">
              <Image src={photo.photo} responsive className="hotel-img" />
              <i className="fa fa-search-plus hotel-photo-overlay" />
            </div>
          </div>
        );
      } else {
        photoList.push(
          <div key={photo.id} className="col-sm-3 col-md-3">
            <div className="caption">
              <h4>Error missing URL for photo {photo.name}</h4>
            </div>
          </div>
        );
      }
    });
    return photoList;
  }
  return (
    <div className="col-md-12">
      <h5 className="hotel-highlight">No photos available</h5>
    </div>
  );
}

class HotelDetailPhotos extends React.Component {
  render() {
    const photos = formatPhotos(this.props.photos);
    return <div>{photos}</div>;
  }
}

HotelDetailPhotos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default HotelDetailPhotos;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelDetailPhotos.js